import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EnquiryReport = () => {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Enquiry Report - Calendar Services";
    $("#daterangepicker").daterangepicker(
      {
        startDate: moment(),
        endDate: moment(),
        ranges: {
          Today: [moment(), moment()],
                  Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                  "Last 7 Days": [moment().subtract(6, "days"), moment()],
                  "Last 30 Days": [moment().subtract(29, "days"), moment()],
                  "This Month": [moment().startOf("month"), moment().endOf("month")],
                  "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
        },
      },
      (start, end) => {
        setStartDate(start.format("YYYY-MM-DD"));
        setEndDate(end.format("YYYY-MM-DD"));
      }
    );
  }, []);

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/enquiry_report`, {
        startDate,
        endDate,
      });
  
      // Assign Serial Number dynamically
      const modifiedData = response.data.map((item, index) => ({
        ...item,
        slNo: index + 1, // Assigning S.No dynamically
      }));
  
      setData(modifiedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  

  const columns = [
    { name: "SlNo", selector: (row) => row.slNo, sortable: true },
    { name: "Name", selector: (row) => row.username, sortable: true },
    { name: "Total Allocated", selector: (row) => row.total_assign, sortable: true },
    { name: "Not Taken", selector: (row) => row.not_taken, sortable: true },
    { name: "Follow-up", selector: (row) => row.followup, sortable: true },
    { name: "Success", selector: (row) => row.success, sortable: true },
    { name: "Delete", selector: (row) => row.deleted, sortable: true },
    { name: "Success Rate", selector: (row) => `${row.average_success_rate}%`, sortable: true },
  ];

  return (
    <div className="max-w-6xl mx-auto mt-8 bg-white p-4">
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">Enquiry Report</h2>
      <div className="text-center mb-6 flex items-center space-x-2 justify-center">
      <input id="daterangepicker" className="border p-2" readOnly />
      
      </div>
      <DataTable columns={columns} data={data} progressPending={loading} pagination />
    </div>
  );
};

export default EnquiryReport;



